import { useState } from 'react';
import { RefreshCw, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAppUpdateContext } from '@/contexts/AppUpdateContext';

/**
 * Seul chemin par lequel une mise a jour est appliquee.
 *
 * Rien n'est recharge automatiquement : un rechargement en pleine saisie
 * (reservation, score) casse le travail de l'utilisateur. Le bandeau signale,
 * l'utilisateur decide. « Plus tard » masque la proposition jusqu'a la version suivante.
 */
export const AppUpdateBanner = () => {
  const { updateAvailable, dismissed, applyUpdate, dismissUpdate } = useAppUpdateContext();
  const [applying, setApplying] = useState(false);

  if (!updateAvailable || dismissed) return null;

  const handleApply = async () => {
    setApplying(true);
    await applyUpdate();
  };

  return (
    <div
      role="status"
      className="fixed inset-x-0 top-0 z-[100] flex flex-wrap items-center justify-center gap-x-3 gap-y-2 bg-primary px-4 py-2 text-primary-foreground shadow-md"
      style={{ paddingTop: 'max(0.5rem, env(safe-area-inset-top))' }}
    >
      <span className="text-sm font-medium">Une nouvelle version est disponible</span>
      <div className="flex shrink-0 items-center gap-2">
        <Button size="sm" variant="secondary" onClick={handleApply} disabled={applying} className="h-8">
          {applying ? (
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          ) : (
            <RefreshCw className="mr-2 h-4 w-4" />
          )}
          Mettre à jour
        </Button>
        <Button
          size="sm"
          variant="ghost"
          onClick={dismissUpdate}
          disabled={applying}
          className="h-8 text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground"
        >
          Plus tard
        </Button>
      </div>
    </div>
  );
};
